import Api from '@/services/api'

export default {
  get_single(params) {
    return Api().get(`users/${params.id}`)
  },
  get_my_account() {
    return Api().get(`users/my-account`)
  },
  get_multiple(params) {
    return Api().get('users', { params: params });
  },
  search(params) {
    return Api().get('users/search', { params: params })
  },
  save(params) {
    return Api().put(`users/${params.id}`, params );
  },
  approve(params) {
    return Api().put(`users/approve/${params.id}`, params );
  },
  delete(params) {
    return Api().delete(`users/${params.id}`, params );
  },
  create(params) {
    return Api().post(`users/create`, params );
  },
  register(params) {
    return Api().post(`users/register`, params );
  },
}